
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Component Specific Imports
import { getCurrentUser, postProfile } from '../actions';

// Libs
import moment from 'moment'

// Bootstrap Resources
import {Button, Col, Panel, Row} from 'react-bootstrap';


const scrollable = {
    height: "600px",
    overflowY: "auto"
};


class EmployerTermsConditions extends Component {

    state = {
        today: moment().format('YYYY-MM-DD')
    };

    componentDidMount () {
        this.props.getCurrentUser();
    }

    async accept () {
        await this.props.postProfile({ acceptedTerms: 1, isRecruiter: true });
        this.props.history.push('/home/employer/onboarding/add_profile');
    };

    termsConditions = () => (
        <p>
            NON-DISCLOSURE AGREEMENT (NDA)
            THIS AGREEMENT dated { this.state.today }, by and between EdutainMe.net (the “Owner”) and (the “Recipient”) in the state of CA .
            WHEREAS, Owner and Recipient, for their mutual benefit and pursuant to a working relationship which has been or may be established, anticipate that Owner may disclose or deliver to Recipient documents, components, parts, information, drawings, data, sketches, plans programs, specifications, techniques, processes, software, inventions and other materials, both written and oral, of a secret, confidential or proprietary nature, including without limitation any and all information relating to marketing, finance, forecasts, invention, research, design or development of information system and any supportive or incidental subsystems, and any and all subject matter claimed in or disclosed by any patent application prepared or filed by or behalf of by Owner, in any jurisdiction, and any amendments or supplements thereto (collectively, “Proprietary Information”); and
            WHEREAS, Owner desires to assure that the confidentiality of any Proprietary Information is maintained;
            NOW, THEREFORE, in consideration of the foregoing premises, and the mutual convenants contained herein, Owner and Recipient hereby agree as follows:
            1. For a period of sixty (60) months from the date hereof, Recipient shall hold in trust and confidence, and not disclose to others or use for Recipient's own benefit or for the benefit of another, any Proprietary Information which is disclosed to Recipient by Owner at any time between the date hereof and sixty (60) months thereafter. Recipient shall disclose Proprietary Information received under this Agreement to person within its organization only if such persons (i) have a need to know and (ii) are bound in writing to protect the confidentiality of such Proprietary Information. This paragraph 1 shall survive and continue after any expiration or termination of this Agreement and shall bind Recipient, its employees, agents, representatives, successors, heirs and assigns.
            2. The undertakings and obligations of Recipient under this Agreement shall not apply to any Proprietary Information which: (a) is described in an issued patent anywhere in the world, is disclosed in a printed publication available to the public, or is otherwise in the public domain through no action or fault of Recipient; (b) is generally disclosed to third parties by Owner without restriction on such third parties, or is approved for release by written authorization of Owner; (c) if not designated “confidential” at the time of first disclosure hereunder, or is not later designated in writing by Owner within thirty (30) days from disclosure to Recipient to be of a secret, confidential or proprietary nature; or (d) is shown to Owner by Recipient, within ten (10) days from disclosure, by underlying documentation to have been known by Recipient before receipt from Owner and/or to have been developed by Recipient completely independent of any disclosure by Owner.
            3. Title to all property received by Recipient from Owner, including all Proprietary Information, shall remain at all times the sole property of Owner, and this Agreement shall not be construed to grant to Recipient any patents, licenses or similar rights to such property and Proprietary Information disclosed to Recipient hereunder.
            4. Recipient shall, upon request of Owner, return to Owner all documents, drawings and other tangible materials, including all Proprietary Information and all manifestation thereof, delivered to Recipient, and all copies and reproductions thereof.
            5. The parties further agree to the following terms and conditions:
            i. Any breach by Recipient of any of Recipient's obligations under this Agreement will result in irreparable inquiry to Owner for which damages and other legal remedies will be inadequate. In seeking enforcement of any of these obligations, Owner will be entitled (in addition to other remedies) to preliminary and permanent injunctive and other equitable relief to prevent, discontinue and/or restrain the breach of this Agreement.
            ii. If any provision of this Agreement is invalid or unenforceable, then such provision shall be construed and limited to the extent necessary, or severed if necessary, in order to eliminate such invalidity or unenforceability, and the other provisions of this Agreement shall not be affected thereby.
            iii. In any dispute over whether information or matter is Proprietary Information hereunder, it shall be the burden of Recipient to show both that such contested information or matter is not Proprietary Information within the meaning of this Agreement, and that it does not constitute a trade secret under the Uniform Trade Secrets Act or successor or similar law in effect in the State listed above.
            iv. No delay or omission by either party in exercising any rights under this Agreement will operate as a waiver of that or any other right. A waiver or consent given by either party on any one occasion is effective only in that instance and will not be construed as a bar to or waiver of any right on any other occasion.
            v. This Agreement shall be binding upon and will inure to the benefit of the parties hereto and their respective successors and assigns.
            vi. This Agreement is governed by and will be construed in accordance with the laws of the State listed above, and the courts of the state listed above shall be the exclusive forum.
            vii. This Agreement is in addition to any prior written agreement between Owner and Recipient relating to the subject matter of this agreement; in the event of any disparity or conflict between the provision of such agreements, the provision which is more protective of Proprietary Information shall control. This Agreement may not be modified, in whole or in part, except by an agreement in writing signed by Owner and Recipient.
            IN WITNESS WHEREOF, the parties have executed this Agreement as of the date first above written.
        </p>
    );

    content () {
        return (
            <div
              className='col-sm-8 col-sm-offset-2'
              style={{ marginTop: "35px" }}
            >
                <Panel style={{ marginBottom: '15px' }}>
                    <Panel.Heading>
                        <Row>
                            <Col md={11}>
                                <p><strong>Terms and Conditions</strong></p>
                            </Col>
                        </Row>
                    </Panel.Heading>
                    <Panel.Body>
                        <div style={scrollable} >
                            { this.termsConditions() }
                        </div>
                    </Panel.Body>
                    <Panel.Footer>
                        <Button onClick={() => this.props.history.push('/home/employer')}>Decline</Button>
                        <Button
                          onClick={() => this.accept()}
                          style={{ marginLeft: '5px' }}
                        >
                            Accept
                        </Button>
                    </Panel.Footer>
                </Panel>
            </div>
        );
    }

    render() {
        return (
            this.content()
        );
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.sharedReducer.currentUser,
    };
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        getCurrentUser,
        postProfile
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployerTermsConditions);
